import React, { useEffect, useRef, useState } from 'react';
import { type Editor } from 'slate';
import styles from '../../../components/Toolbar/Toolbar.module.css';
import ColorPicker from '../../../components/ColorPicker/ColorPicker';
import { ReactEditor } from 'slate-react';
import ColorUtils from '../../../util/color';
import classnames from 'classnames';

interface TableBorderColorToolbarComponentProps {
  editor: Editor;
  getBorderColor: () => string | undefined;
  setBorderColor: (color?: string) => void;
  active?: boolean;
  enabled?: boolean;
}

const TableBorderColorToolbarComponent: React.FC<
  TableBorderColorToolbarComponentProps
> = ({ editor, getBorderColor, setBorderColor, active, enabled }) => {
  const menuRef = useRef<HTMLElement>();
  const [currentColor, setCurrentColor] = useState(getBorderColor());

  useEffect(() => {
    setCurrentColor(getBorderColor());
  }, [editor, editor.selection]);

  const handleColorChange = (color: string, focusEditor?: boolean) => {
    const mappedColor = ColorUtils.mapColorFromColorPickerFromDarkMode(color);

    setBorderColor(mappedColor);
    setCurrentColor(mappedColor);

    if (focusEditor) {
      ReactEditor.focus(editor);
    }
  };

  const handleClearColor = () => {
    const color = 'transparent';
    setBorderColor(color);
    setCurrentColor(color);
    ReactEditor.focus(editor);
  };

  return (
    <aha-menu ref={menuRef}>
      <div slot="control">
        <div
          className={styles.toolbarButton}
          aria-selected={active}
          aria-disabled={!enabled}
        >
          {currentColor === 'transparent' ? (
            <span
              className={classnames(
                styles.borderColorIcon,
                styles.colorIconNone
              )}
            />
          ) : (
            <span
              className={styles.borderColorIcon}
              style={currentColor ? { borderColor: currentColor } : {}}
            />
          )}
        </div>
      </div>
      <aha-menu-content>
        <ColorPicker
          currentColor={
            !currentColor || currentColor === 'transparent'
              ? '#000000'
              : currentColor
          }
          handleColorChange={handleColorChange}
          handleClearColor={handleClearColor}
          handleCloseMenu={() => menuRef.current?.removeAttribute('open')}
          showCustomColorInput
          showClearButton
        />
      </aha-menu-content>
    </aha-menu>
  );
};

export default TableBorderColorToolbarComponent;
